import { Input } from "@/components/ui/input"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { IconSearch, IconX } from "@tabler/icons-react"

interface HelpdeskSearchFieldProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
  className?: string
}

export function HelpdeskSearchField({
  value,
  onChange,
  placeholder,
  className,
}: HelpdeskSearchFieldProps) {
  const { translate } = useTranslation()
  return (
    <div className={cn("relative w-full flex-1", className)}>
      <IconSearch className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        placeholder={placeholder}
        aria-label={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={cn(
          "h-10 rounded-lg border-grey4 bg-card pl-9 text-sm shadow-none focus-visible:border-yellow1 focus-visible:ring-0",
          value && "pr-9",
        )}
        data-testid="help-search-input"
      />
      {value ? (
        <button
          type="button"
          aria-label={translate("SEARCH_FIELD/CLEAR")}
          onClick={() => onChange("")}
          className="absolute top-1/2 right-3 -translate-y-1/2 rounded-sm text-muted-foreground hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        >
          <IconX className="size-3.5" />
        </button>
      ) : null}
    </div>
  )
}
